import React from "react";
import { TextField } from "@mui/material";
import { AppGridColDef } from "../EditableDataGridStyle";

interface EmailEditColumnProps {
  params: any;
  required?: boolean;
  fieldName?: string;
}

export const EmailEditColumn: React.FC<EmailEditColumnProps> = ({
  params,
  required = false,
  fieldName = "email",
}) => {
  const [value, setValue] = React.useState<string>(params.value || "");
  const [error, setError] = React.useState<boolean>(false);

  const validateEmail = (email: string): boolean =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    setError(required && !validateEmail(newValue));
    params.api.setEditCellValue({
      id: params.id,
      field: fieldName,
      value: newValue,
    });
  };

  return (
    <TextField
      fullWidth
      value={value}
      onChange={handleChange}
      error={error}
      helperText={error ? "אימייל לא תקין" : ""}
      placeholder="user@example.com"
    />
  );
};


